<template>
    <div class="sizeContainer ">
        <div class="backgroundComponent" />
        <div class="boxesWrapper">
            <div class="groupButtons" :style="isItemProfil ? 'left: 40% !important;' : '' "> 

                <!-- v-if="this.visibleRange && this.visibleRange.start > 0"  -->

                
                <div class="arrowWrapper left" @click="scroll(-1)">
                    <img  alt="" class="" src="@/assets/icons/fi-rr-angle-small-left-dark.svg" :style="isArrowLeftActive ? 'opacity:1' : 'opacity:0.2'" />  

                </div>
                <div v-for="(size, index) in visibleSizes" :key="index" class="sizeBox" :class="{ sizeBoxDisabled: !isSizeInStock(size), clicked: selectedSize === index, active: selectedSize === size  }"
                    @click="selectSize(size)">
                    <div class="sizeTitle" :class="{ sizeTitleDisabled: !isSizeInStock(size)}" >{{ size }}</div>
                </div>

                <div v-if="!sizeNames.length" class="sizeBox text-danger">
                    <span>Non Disponible</span>
                </div>

                <!-- v-if="this.visibleRange && this.sizeNames && this.visibleRange.end < this.sizeNames.length - 1" -->
                <div  class="arrowWrapper right" @click="scroll(1)">
                    <img  alt="" class="" src="@/assets/icons/fi-rr-angle-small-right-dark.svg"  :style="isArrowRightActive ? 'opacity:1' : 'opacity:0.2'" />  
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "SizeComponent",
    props: {
        sizes: Object,
        selectedColor:Object,
        isItemProfil : Boolean ,
        available:{
          type:Boolean,
          default:false
      },
    },

    data() {
        return {
            visibleRange: { start: 0, end: 3 }, // Initial visible range
            selectedSize: null,
        };
    },
    computed: {
        visibleSizes() {
            return this.sizeNames.slice(this.visibleRange.start, this.visibleRange.end + 1);
        },

        sizeNames() {
            if (this.selectedColor){
                return this.sizes ? Object.keys(this.sizes).filter(size => this.sizes[size].some(obj => obj.color.name === this.selectedColor.color.name)) : null;
            }
            else{
                return this.sizes ? Object.keys(this.sizes) : null;
        }
        },
      
        isArrowRightActive() {
            return this.visibleRange && this.sizeNames && this.visibleRange.end < this.sizeNames.length - 1
        },

        isArrowLeftActive() {
            return this.visibleRange && this.visibleRange.start > 0
        },
    },
    methods: {
        scroll(direction) {
            const step = 1; // Number of sizeNames to scroll

            if (direction === 1) {
                // Scroll right
                if (this.visibleRange.end < this.sizeNames.length - 1) {
                    this.visibleRange.start = Math.min(this.visibleRange.start + step, this.sizeNames.length - 4);
                    this.visibleRange.end = Math.min(this.visibleRange.end + step, this.sizeNames.length - 1);
                }
            } else if (direction === -1) {
                // Scroll left
                if (this.visibleRange.start > 0) {
                    this.visibleRange.start = Math.max(this.visibleRange.start - step, 0);
                    this.visibleRange.end = Math.max(this.visibleRange.end - step, 3);
                }
            }
        },

        getTotalStockOfSize( sizeName) {
            return Object.entries(this.sizes)
            .filter(([size]) => !sizeName || size === sizeName)
            .flatMap(([, items]) => items)
            .filter(item => item.color.id === this.selectedColor.color.id)
            .reduce((total, item) => total + item.stock, 0);
        },



        isSizeInStock(sizeName) {
            if (!this.sizes) {
                return false;
            }

             if (this.selectedColor && !this.getTotalStockOfSize( sizeName) ) {
                return false;
            } 

            if (this.available) {
                return true;
            }

            if ( this.sizes[sizeName] && Array.isArray(this.sizes[sizeName]) &&  this.sizes[sizeName].some(item => item.stock !== 0)) {
                return true;
            }

            return false;
        },

        selectSize(size) {

            if (this.selectedSize == size) {
                this.selectedSize = null;
                this.$emit('size-selected', null);
            } else {
                this.selectedSize = size;
               
            }

            this.$emit('size-selected', this.selectedSize);
        },
    },
};
</script>
  
<style scoped>
.backgroundComponent {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0%;
    right: 0%;
    bottom: 0%;
    left: 0%;
    background-color: rgba(255, 255, 255, 0.7);
}

.sizeTitle {
    position: relative;
    line-height: 22px;
}

.sizeTitleDisabled {
    color: #918d8dba;
    text-decoration: line-through;
}

.sizeTitleDisabled:hover {
    text-decoration: line-through;
}

.sizeBox {
    border: 1px solid #ddd;
    box-sizing: border-box;
    height: 38px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 20px 20px;

    width:55px;
    height: 25px;

    cursor: pointer;
    transition: border-color 0.3s; 
    font-family: 'Space Grotesk' !important;
    font-weight: bold;

    background-color: #ffffffd1;
}

.sizeBox:hover {
    border-color: #000;
    background-color: #000;
    color:white;  
    cursor: pointer;
}

.sizeBox.active {
    border-color: #000;
    background-color: #000;
    color:white;  
    cursor: pointer;
}

.sizeBoxDisabled.active {
    border-color: #ddd;
    background-color: #e9e8e8;
    color: #000;
}

.sizeBoxDisabled:hover {
    border-color: #ddd;
    background-color: #e9e8e8;
    color: #000;
    /*cursor: auto;*/
}

.groupButtons {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
}

.boxesWrapper {
    position: absolute;
    height: 73.08%;
    width: 92.93%;
    top: 13.46%;
    right: 3.53%;
    bottom: 13.46%;
    left: 3.53%;
}

.sizeContainer {
    position: relative;
    width: 100%;
    height: 52px;
    text-align: center;
    font-size: 14px;
    color: #121212;
    font-family: Inter;
}

.arrowWrapper {
    cursor: pointer;
}

.arrowIcon {
    width: 20px;
    height: 20px;
}
</style>
